import { useEffect, useRef, useState } from "react";

interface IntersectionObserverOptions extends IntersectionObserverInit {
  //handle event when component first visible
  onVisible?: (isVisible: boolean) => void;
}

const useElementOnScreen = (options: IntersectionObserverOptions) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLElement | undefined>(undefined);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) =>
        setIsVisible((isVisible) => {
          if (isVisible) {
            //notify when component is visible
            options.onVisible?.(true);
            return isVisible;
          }
          return entry.isIntersecting;
        }),
      options
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [options]);

  return { ref, isVisible };
};

export default useElementOnScreen;
